const config = {
    LOCAL_API_URL: 'https://mss-ubuntu.dstmp.com/api/api',
}
export default config
